const sections = [
  { title: '围观栏目', links: [['现场直击', '#live'], ['瓜田速递', '#feed'], ['实况还原', '#deep'], ['热搜榜', '#trending']] },
  { title: '新手专区', links: [['吃瓜指南', '#guide'], ['关于我们', '#about'], ['订阅瓜田晚报', '#newsletter'], ['返回顶部', '#start']] },
];

export default function Footer() {
  return (
    <footer className="w-full border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-2">
            <a href="#start" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 font-display text-lg font-bold text-background-50">瓜</span>
              <span className="font-display text-lg font-bold leading-none text-foreground-950">
                吃瓜现场
                <span className="mt-0.5 block text-[10px] font-label font-normal tracking-wide text-foreground-500">群众围观现场 · 实况还原</span>
              </span>
            </a>
            <p className="mt-4 max-w-sm text-sm leading-6 text-foreground-600">
              一处面向全网吃瓜群众的围观平台，专注热点事件现场直击与实况还原。实时速递、深度解析、理性围观，让每一次吃瓜都吃得明明白白。
            </p>
            <div className="mt-4 flex flex-wrap items-center gap-2">
              <a href="mailto:hello@guachang.online" aria-label="发邮件" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"><i className="text-base ri-mail-line" /></a>
              <a href="#start" aria-label="主页" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"><i className="text-base ri-home-5-line" /></a>
              <a href="#newsletter" aria-label="订阅" className="flex h-9 w-9 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-colors hover:bg-primary-500 hover:text-background-50"><i className="text-base ri-news-line" /></a>
            </div>
          </div>

          {sections.map((col) => (
            <nav key={col.title} aria-label={col.title}>
              <h4 className="font-display text-sm font-bold text-foreground-950">{col.title}</h4>
              <ul className="mt-4 space-y-2.5">
                {col.links.map(([label, href]) => (
                  <li key={href}>
                    <a href={href} className="text-sm text-foreground-600 transition-colors hover:text-primary-700">{label}</a>
                  </li>
                ))}
              </ul>
            </nav>
          ))}
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">© {new Date().getFullYear()} 吃瓜现场 · 群众围观现场。内容仅供信息参考，理性围观，不信谣不传谣。</p>
          <div className="flex flex-wrap items-center gap-4 text-xs text-foreground-500">
            <a href="#guide" className="hover:text-primary-700">吃瓜指南</a>
            <a href="#about" className="hover:text-primary-700">关于我们</a>
            <a href="#newsletter" className="hover:text-primary-700">订阅</a>
          </div>
        </div>
      </div>
    </footer>
  );
}